import React, { useState } from "react";
import { BASE_URL } from "../../constants";
import "./styles.css";
import { cardClick, isCardSelected } from "./controller";

const CardInfoDoctorComponent = ({
  selectedAppointment,
  setAppointmentSelected,
  appointmentSelectedByClickOnCard,
}) => {
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const sortedAppointments = [...selectedAppointment].sort((a, b) => {
    const [hourA] = a.hour.split(" - ");
    const [hourB] = b.hour.split(" - ");
    return hourA.localeCompare(hourB, "en", { numeric: true });
  });

  const onErrorImage = (event) => {
    event.target.style.display = "none";
    event.target.parentNode.innerHTML = `<p class="avatarTextCardDoctor">${event.target.alt}</p>`;
  };

  return (
    <div className="containerCardInfoDoctor">
      {sortedAppointments.map((appointment) => (
        <div
          key={appointment.id}
          className={`cardInfoDoctor ${
            isCardSelected(appointment, selectedAppointmentId)
              ? "selectedCard"
              : ""
          }`}
          onClick={() =>
            cardClick(
              appointment,
              selectedAppointmentId,
              setSelectedAppointmentId,
              setAppointmentSelected,
              appointmentSelectedByClickOnCard
            )
          }
        >
          <div className="imageColumnCardDoctor">
            {appointment.doctor.urlImage ? (
              <img
                src={BASE_URL + appointment.doctor.urlImage}
                onError={onErrorImage}
                alt={appointment.doctor.avatar}
              />
            ) : (
              <p className="avatarTextCardDoctor">
                {appointment.doctor.avatar}
              </p>
            )}
          </div>
          <div className="infoColumn">
            <div className="doctorInfo">
              <p className="doctorName">{appointment.doctor.name}</p>
              <p className="appointmentHour">{appointment.hour}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardInfoDoctorComponent;
